import type { BridgeMcpToolCallResult, BridgeMcpToolContext } from '../../../bridge-mcp-tool-types.js';
import { fetchCloudParentTurnTranscript } from '../cloud/fetch-parent-transcript.js';
import { mcpTextResult } from './mcp-text-result.js';

export async function callGetParentSessionTurnTranscriptTool(
  ctx: BridgeMcpToolContext,
  cloud: { cloudApiBaseUrl: string; getCloudAccessToken: () => string },
  childSessionId: string,
  args: Record<string, unknown>,
): Promise<BridgeMcpToolCallResult> {
  const turnId = typeof args.turnId === 'string' ? args.turnId.trim() : '';
  if (!turnId) return mcpTextResult('turnId is required.', true);
  const transcript = await fetchCloudParentTurnTranscript({
    childSessionId,
    turnId,
    cloudApiBaseUrl: cloud.cloudApiBaseUrl,
    getCloudAccessToken: cloud.getCloudAccessToken,
    e2ee: ctx.e2ee,
  });
  if (!transcript.ok) return mcpTextResult(transcript.error, true);
  return mcpTextResult(transcript.text);
}
